import { IDataLayer, LayerZone } from "../types"

export function getCurrentAnalysisLayer(field: { fieldId: number }, year: number, layers: IDataLayer[]) {

    layers = layers
        .filter(l => l.FieldId === field.fieldId)
        .filter(l => (!l.FirstYearId) || (l.FirstYearId <= year))
        .sort((a, b) => (b.FirstYearId - a.FirstYearId) || (b.DataLayerId - a.DataLayerId))

    return layers.length ? layers[0] : null

}

export function getLayerZoneId(zone: LayerZone) {

    return zone && zone.layer && zone.zone
        ? {
            fieldId: zone.layer.fieldId,
            croppingId: zone.layer.croppingId,
            layerId: zone.layer.datalayerId,
            zoneId: zone.zone.DataLayerZoneId
        }
        : undefined

}
